// v4 — Goal Tracker
import React from 'react';
import { v4data, GOALS, sumRange, seriesRange } from './v4data';
import { Bars, Ring } from './viz';
import { PageHeader, DatePill, Card, StatCard, Pill, fmtK, fmt$, fmtX, fmt$2 } from './v4ui';
import markPhoto from 'static/images/v4/mark.png';
import './dashboard.scss';

export default function GoalTrackerV4() {
  const D = v4data(30);
  const today = D.to;
  const [yy, mm] = today.split('-');
  const monthStart = `${yy}-${mm}-01`;
  const daysInMonth = new Date(parseInt(yy), parseInt(mm), 0).getDate();
  const mtd = sumRange(D.ds.accountDaily, monthStart, today);
  const mtdSeries = seriesRange(D.ds.accountDaily, monthStart, today).map((d) => d.totals.revenue);
  const dayGoal = GOALS.revenue / daysInMonth;
  const dayCount = mtdSeries.length;
  const pace = (mtd.revenue / (dayGoal * dayCount)) * 100;
  const projected = (mtd.revenue / dayCount) * daysInMonth;

  const coach = [
    { m: 'Store Revenue', ok: projected >= GOALS.revenue, txt: projected >= GOALS.revenue ? 'projected above goal' : 'pacing below goal' },
    { m: 'MER', ok: D.cur.roas >= GOALS.mer, txt: D.cur.roas >= GOALS.mer ? 'above goal' : 'below goal' },
    { m: 'AOV', ok: D.cur.aov >= GOALS.aov, txt: D.cur.aov >= GOALS.aov ? 'above goal' : 'below goal' },
    { m: 'Cost / Order', ok: D.cur.cpp <= (GOALS.revenue / GOALS.mer) / (GOALS.revenue / GOALS.aov), txt: 'near goal' },
  ];

  return (
    <div className="v4-dash">
      <PageHeader title="Goal Tracker" sub={`Store revenue goal · ${new Date(parseInt(yy), parseInt(mm) - 1).toLocaleString('en', { month: 'long' })}`} live right={<DatePill>This month</DatePill>} />

      <section className="v4-statstrip">
        <StatCard label="Target Revenue" value={fmtK(GOALS.revenue)} />
        <StatCard label="Actual (MTD)" value={fmtK(mtd.revenue)} valueColor="#8AE8BD" />
        <StatCard label="Projected" value={fmtK(projected)} valueColor="#7A75F6" />
        <StatCard label="Pace to Goal" value={pace.toFixed(0) + '%'} valueColor="#5A54F3" />
      </section>

      <section className="v4-secrow v4-gt-secrow">
        <Card title="Store Revenue" sub="Daily vs goal line · month to date">
          <Bars data={mtdSeries} goal={dayGoal} h={230} colorFor={(v) => (v >= dayGoal ? '#8AE8BD' : '#5A54F3')} />
          <div className="v4-goal-note">Goal line = <b>{fmt$(dayGoal)}</b>/day · bars above the line beat pace</div>
        </Card>

        <div className="v4-side">
          <Card title="Pace" className="v4-pace-card">
            <div className="v4-pace-row">
              <div className="v4-pace-left">
                <Ring pct={pace} size={300} thickness={21} label={pace.toFixed(0) + '%'} sub="OF PACE" />
                <div className="v4-ring-stats">
                  <div><span className="l">Projected</span><span className="v" style={{ color: '#7A75F6' }}>{fmtK(projected)}</span></div>
                  <div><span className="l">vs Target</span><span className="v pos">{projected >= GOALS.revenue ? '+' : ''}{fmtK(projected - GOALS.revenue)}</span></div>
                </div>
              </div>
              <div className="v4-pace-mark">
                <div className="pm-head"><img src={markPhoto} alt="Mark" /><div className="pm-id"><b>Mark</b><span>AI Media Buyer</span></div><span className="pm-live"><i /> live</span></div>
                <p className="pm-text">
                  <b>You're pacing at {pace.toFixed(0)}% of goal.</b> I've got you landing near {fmtK(projected)}, {projected >= GOALS.revenue ? 'well over' : 'just under'} target. I'm keeping spend efficient and leaning into the winners. Approve and I'll hold this pace right through month-end.
                </p>
                <div className="pm-actions">
                  <button className="mark-approve">Approve the pace plan</button>
                  <button className="mark-ghost">Show me the math</button>
                </div>
              </div>
            </div>
          </Card>
          <Card title="Coaching">
            <ul className="v4-coach">
              {coach.map((c) => (<li key={c.m}><i className={c.ok ? 'ok' : 'warn'} /><span className="cm">{c.m}</span><span className="ct">{c.txt}</span></li>))}
            </ul>
          </Card>
        </div>
      </section>
    </div>
  );
}
